import { createSlice } from '@reduxjs/toolkit';
import { post } from 'api/fetch';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'global/forgotPassword',
  initialState: {
    isLoading: false,
    error: null,
    isSent: false,
    isReset: false,
    resendInvitation: false
  },
  reducers: {
    // resetPasswordEmailRequest
    resetPasswordEmailRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    resetPasswordEmailSuccess: (state) => {
      state.isLoading = false;
      state.error = null;
      state.isSent = true;
    },
    resetPasswordEmailFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.isSent = false;
    },
    // resetPasswordRequest
    resetPasswordRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    resetPasswordSuccess: (state) => {
      state.isLoading = false;
      state.error = null;
      state.isReset = true;
    },
    resetPasswordFailure: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.isReset = false;
    },
    // resetPasswordRequest
    resendMemberInvitation: (state) => {
      state.resendInvitation = true;
      state.isSent = false;
      state.isLoading = true;
      state.error = null;
    },
    resendMemberInvitationSuccess: (state) => {
      state.isSent = true;
      state.isLoading = false;
      state.error = null;
    },
    resendMemberInvitationFailure: (state, { payload }) => {
      state.resendInvitation = false;
      state.isSent = false;
      state.isLoading = false;
      state.error = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const resetPasswordEmail = (email) => async (dispatch) => {
  dispatch(actions.resetPasswordEmailRequest());

  try {
    await post('/users/reset-password-email', { email });

    dispatch(actions.resetPasswordEmailSuccess());
  } catch (error) {
    dispatch(actions.resetPasswordEmailFailure(error));
  }
};

export const resetPassword = (email, password, resetToken) => async (dispatch) => {
  dispatch(actions.resetPasswordRequest());

  try {
    await post('/users/reset-password', { email, password, resetToken });

    dispatch(actions.resetPasswordSuccess());
  } catch (error) {
    dispatch(actions.resetPasswordFailure(error));
  }
};

export const resendMemberInvitation = (email) => async (dispatch) => {
  dispatch(actions.resendMemberInvitation());

  try {
    await post('/users/resend-company-member-invitation', { email });

    dispatch(actions.resendMemberInvitationSuccess());
  } catch (error) {
    dispatch(actions.resendMemberInvitationFailure(error));
  }
};
